import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { actions as recoveryPasswordActions, selectors as recoveryPasswordSelectors } from "reducers/recoveryPassword";
import { actions as loginActions } from "reducers/login";

import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import Step3Content from "pages/recoveryPassword/_components/Step3Content";
import Step3Username from "pages/recoveryPassword/_components/Step3Username";

import Head from "pages/_components/Head";
import withExchangeToken from "pages/_components/withExchangeToken";
import { goBack } from "connected-react-router";

class RecoveryPassStep3 extends Component {
    componentWillUnmount() {
        this.props.dispatch(recoveryPasswordActions.recoveryPassCleanUp());
    }

    onHeaderClose = () => {
        this.props.dispatch(loginActions.reset());
    };

    onHeaderBack = () => {
        const { dispatch } = this.props;
        dispatch(goBack());
    };

    render() {
        const mainContainerClass = classNames({
            "main-container": true,
            "container-fluid": this.props.isDesktop,
        });

        const recoveryType = this.props?.match?.params?.recoveryType;

        return (
            <React.Fragment>
                <Head
                    title=""
                    styleOther={{ backgroundColor: "transparent", boxShadow: "none" }}
                    onBack={this.onHeaderBack}
                    hideNavbarInMobile
                />
                <Notification scopeToShow="recoveryPassword" />

                <MainContainer className={mainContainerClass}>
                    {recoveryType === "username" ? <Step3Username {...this.props} /> : <Step3Content {...this.props} />}
                </MainContainer>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    exchangeToken: recoveryPasswordSelectors.getExchangeToken(state),
    resetCode: recoveryPasswordSelectors.getResetCode(state),
});

export default connect(mapStateToProps)(withExchangeToken(RecoveryPassStep3));
